import { useState } from "react";
import {
  Container,
  Grid,
  Typography,
  Paper,
  Box,
} from "@mui/material";
import Login from "../../components/authcomponents/Login";
import SignUp from "../../components/authcomponents/SignUp";

const AuthPage = () => {
  const [isLogin, setIsLogin] = useState(true);

  const handleToggle = () => {
    setIsLogin(!isLogin);
  };

  return (
    <Container
      maxWidth={false}
      disableGutters
      sx={{
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        mt: 0,
      }}
    >
      <Grid
        container
        sx={{
          minHeight: "100vh",
          background: "url(/assets/Cycling.png) no-repeat center center",
          backgroundSize: "cover",
        }}
      >
        <Grid container sx={{ minHeight: "100vh" }}>
          <Grid
            item
            xs={12}
            sm={6}
            sx={{
              display: { xs: "none", sm: "block" },
              backgroundImage: "url(/assets/Rectanglee.png)",
              backgroundRepeat: "no-repeat",
              backgroundSize: "cover",
              backgroundPosition: "center",
              position: "relative",
              px: { sm: 2, md: 4 },
              py: { sm: 4, md: 8 },
            }}
          >
            <Box
              sx={{
                position: "absolute",
                color: "#BB84E8",
                top: 30,
                left: 100,
                fontSize: "2rem",
                fontWeight: 800,
                fontFamily: "Vollkorn",
              }}
            >
              G2i
            </Box>
            <Box
              sx={{
                height: "100%",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                flexDirection: "column",
                color: "white",
              }}
            >
              <Typography
                variant="h2"
                align="center"
                sx={{
                  fontWeight: "bold",
                  fontSize: { xs: "3rem", md: "6rem" },
                  lineHeight: "1.2",
                  marginBottom: "2.6rem",
                }}
              >
                {isLogin ? (
                  <>
                    {" "}
                    <Typography
                      variant="h2"
                      align="center"
                      sx={{
                        fontWeight: "800",
                        fontSize: { xs: "2rem", sm: "4rem" },
                      }}
                    >
                      G2I
                    </Typography>
                    <Typography
                      variant="h4"
                      align="center"
                      sx={{ fontSize: { xs: "1.5rem", sm: "3rem" } }}
                    >
                      Global Genius Index (G2I)
                    </Typography>
                  </>
                ) : (
                  <>
                    {" "}
                    <Typography
                      variant="h2"
                      align="center"
                      sx={{
                        fontWeight: "bold",
                        fontSize: { xs: "3rem", md: "6rem" },
                        lineHeight: "1.2",
                        marginBottom: "2rem",
                      }}
                    >
                      Discover
                    </Typography>
                    <Typography
                      variant="h4"
                      align="center"
                      sx={{
                        fontWeight: "bold",
                        fontSize: { xs: "3rem", md: "6rem" },
                        lineHeight: "1.4",
                        marginBottom: "2rem",
                      }}
                    >
                      within <br />
                      you
                    </Typography>
                  </>
                )}
              </Typography>

              {/* Background shapes */}
              <Box
                sx={{
                  position: "absolute",
                  top: 30,
                  left: "calc(100% - 110px)",
                  transform: "translateX(-50%)",
                }}
              >
                <img
                  src="/assets/Polygon.png"
                  alt="Polygon"
                  style={{ width: "220px", height: "220px" }}
                />
              </Box>
              <Box
                sx={{
                  position: "absolute",
                  top: 200,
                  left: 150,
                  transform: "translateX(-50%)",
                }}
              >
                <img
                  src="/assets/Polygon.png"
                  alt="Polygon"
                  style={{ width: "100px", height: "100px" }}
                />
              </Box>
              <Box
                sx={{
                  position: "absolute",
                  bottom: 120,
                  left: 190,
                  transform: "translateX(-50%)",
                }}
              >
                <img
                  src="/assets/Ellipse.png"
                  alt="Ellipse"
                  style={{ width: "380px", height: "260px" }}
                />
              </Box>
              <Box
                sx={{
                  position: "absolute",
                  bottom: 200,
                  left: 585,
                  transform: "translateX(-50%)",
                }}
              >
                <img
                  src="/assets/Ellipse 9.png"
                  alt="Ellipse"
                  style={{ width: "100px", height: "100px" }}
                />
              </Box>
              <Box
                sx={{
                  position: "absolute",
                  bottom: 120,
                  left: 650,
                  transform: "translateX(-50%)",
                }}
              >
                <img
                  src="/assets/Ellipse 9.png"
                  alt="Ellipse"
                  style={{ width: "60px", height: "60px" }}
                />
              </Box>
            </Box>
          </Grid>

          <Grid
            item
            xs={12}
            sm={6}
            sx={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              py: 8,
            }}
          >
            <Box
              sx={{
                width: { xs: "100%", sm: "500px" },
                minHeight: "110vh",
                px: { xs: 3, sm: 0 },
              }}
            >
              <Typography
                sx={{
                  display: "flex",
                  justifyContent: "center",
                  mb: 0,
                  fontWeight: 600,
                }}
              >
                <Typography
                  sx={{
                    width: "50%",
                    borderBottom: isLogin
                      ? "2px solid gray"
                      : "2px solid #321548",
                    fontWeight: 700,
                    pb:2,
                    color: isLogin ? "gray" : "#321548",
                    textAlign: "center",
                    cursor: "pointer",
                  }}
                  onClick={handleToggle}
                >
                  Create Account
                </Typography>
                <Typography
                  sx={{
                    width: "50%",
                    borderBottom: isLogin
                      ? "2px solid #321548"
                      : "2px solid gray",
                    fontWeight: 700,
                    color: isLogin ? "#321548" : "gray",
                    textAlign: "center",
                    cursor: "pointer",
                  }}
                  onClick={handleToggle}
                >
                  Log In
                </Typography>
              </Typography>
              <Paper
                elevation={0}
                sx={{
                  padding: { xs: 2, sm: 4 },
                  backgroundColor: "transparent",
                  boxShadow: "none",
                }}
              >
                {isLogin ? (
                  <>
                    <Login />
                  </>
                ) : (
                  <>
                    <SignUp />
                  </>
                )}
              </Paper>
              <Box sx={{ textAlign: "center", mt: 4 }}>
                <Box
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    color: "#746283",
                    mb: 4,
                  }}
                >
                  <Box
                    sx={{ flex: 1, borderBottom: "2px solid gray", mr: 2 }}
                  ></Box>
                  <Typography sx={{ fontWeight: 700, whiteSpace: "nowrap" }}>
                    or Sign Up With
                  </Typography>
                  <Box
                    sx={{ flex: 1, borderBottom: "2px solid gray", ml: 2 }}
                  ></Box>
                </Box>
                <Box
                  sx={{ display: "flex", justifyContent: "center", gap: 14 }}
                >
                  <img
                    src="/assets/Group.png"
                    alt="Logo 1"
                    style={{ width: "60px", height: "60px" }}
                  />
                  <img
                    src="/assets/apple-black 1.png"
                    alt="Logo 2"
                    style={{ width: "60px", height: "60px" }}
                  />
                </Box>
              </Box>
            </Box>
          </Grid>
        </Grid>
      </Grid>
    </Container>
  );
};

export default AuthPage;
